import { v4 as uuidv4 } from 'uuid'
import Log from './Log'
import Storage from './Storage'

let userId = null

export default class User {
  static async init () {
    // Ensure user ID
    userId = await Storage.get('user-id', null)
    if (userId === null) {
      Log.info('User ID not found. Generating ...')
      userId = uuidv4()
      await Storage.set('user-id', userId)
    }
  }

  static id () {
    return userId
  }
}
